import { connect } from 'react-redux'
import DisplayActions from '../../../../../redux/DisplayRedux'
import ScreensOutputSettingsComponent from '../../components/step2_settings/ScreensOutputSettingsComponent'

const mapStateToProps = ({ display, userAccount }) => ({
  date_from: display.date_from,
  date_to: display.date_to,
  managerDisplayFilter: display.managerDisplayFilter,
  managerDisplaySelector: display.managerDisplaySelector,
  disabledManagerDisplayFilter: display.disabledManagerDisplayFilter,
  isSuperUser: userAccount.isSuperUser,
  user: userAccount.user,
  customContents: display.customContents,
  cart: display.cart,
  realAmount: display.realAmount,
  isPaymentStatusApproved: display.isPaymentStatusApproved,
  programmatic: display.programmatic,
  isGuaranteed: display.isGuaranteed,
  display: display.display,
  audience: display.audience,
  loadingOptimizeRules: display.loadingOptimizeRules,
  optimizeRulesResult: display.optimizeRulesResult,
  optimizeRulesError: display.optimizeRulesError,
})

const mapStateToDispatch = (dispatch) => ({
  disableManagerDisplayFilter: (disabledManagerDisplayFilter) => dispatch(DisplayActions.disableManagerDisplayFilter(disabledManagerDisplayFilter)),
  setManagerDisplayFilter: (nameFilter) => dispatch(DisplayActions.setManagerDisplayFilter(nameFilter)),
  setManagerDisplaySelector: (nameFilter) => dispatch(DisplayActions.setManagerDisplaySelector(nameFilter)),
  updateCustomContents: (customContents) => dispatch(DisplayActions.updateCustomContents(customContents)),
  updateRulesRelationScreen: (displayId, relationId, newRules) => dispatch(DisplayActions.updateRulesRelationScreen(displayId, relationId, newRules)),
  setLibraryRules: (libraryRules) => dispatch(DisplayActions.setLibraryRules(libraryRules)),
  optimizeRulesRequest: (params) => dispatch(DisplayActions.optimizeRulesRequest(params)),
})

export default connect(mapStateToProps, mapStateToDispatch)(ScreensOutputSettingsComponent)